import {RemoteGetRequestPreviewProtocolPdf} from 'data/usecases';
import {GetRequestPreviewProtocolPdf} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from 'main/factories/usecases';

export const makeGetRequestPreviewProtocolPdf = (): GetRequestPreviewProtocolPdf =>
	new RemoteGetRequestPreviewProtocolPdf(
		makeBFFApiUrl(RefundFlowEndPoints.requestPreviewProtocolPdf),
		makeAuthorizeHttpClientDecorator(),
	);
